// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix =
  'vote/2026project/q2/2026cq_creative_works/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const educationList = () => {
  return http.get(`${urlPrefix}education-list`);
};

const save = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data), {});
};
const userList = (workType: number) => {
  return http.get(`${urlPrefix}user-list&workType=${workType}`, {});
};
const userDetail = (id: string) => {
  return http.get(`${urlPrefix}user-detail&id=${id}`, {});
};

// 新闻
const TEST_API = 'https://t8-testapi-proxy.cqcb.com';
const PRO_API = 'https://t8-api-proxy.cqcb.com';

const getNewsList = (data: any) => {
  let path = '';
  if (process.env.VUE_APP_ENV_NAME === 'development') {
    path = '/wap/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'TEST') {
    path = TEST_API + '/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'production') {
    path = PRO_API + '/api/v1/newsListColumn';
  }
  return http.get(path, { params: data });
};

export { getBaseInfo, educationList, save, userList, userDetail, getNewsList };
